module.exports = __webpack_public_path__ + "css/OffgridEnergy.7d41bc0c.css";